import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllInformacoesEntregaObraClienteUseCase } from "../../../presentation/useCases/read/get_all_informacoes_entrega_obra_cliente_use_case";
import { InformacoesEntregaObraClienteModel } from "../../models/informacoes_entrega_obra_cliente";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllInformacoesEntregaObraClienteUseCase
 */

export class GetAllInformacoesEntregaObraClienteUseCase
  extends BasePaginatedUseCase<InformacoesEntregaObraClienteModel>
  implements IGetAllInformacoesEntregaObraClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(idEntregaObraCliente: number): Promise<void> {
    const result = await this.repository.getAllInformacoesEntregaObrasCliente(idEntregaObraCliente);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }
}
